import React, { useEffect, useState } from 'react';
import '../css/discord-login.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';

const Login = () => {
  const [redirect, setRedirect] = useState('/');

  const BASE_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? process.env.REACT_APP_PRODUCTION_BASE_URL : process.env.REACT_APP_DEVELOPMENT_BASE_URL;
  const PORT = process.env.REACT_APP_ENVIRONMENT === 'production' ? process.env.REACT_APP_PRODUCTION_PORT : process.env.REACT_APP_DEVELOPMENT_PORT;
  const API_BASE_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? process.env.REACT_APP_PRODUCTION_API_BASE_URL : process.env.REACT_APP_DEVELOPMENT_API_BASE_URL;

  useEffect(() => {
    let urlParams = new URLSearchParams(window.location.search);
    setRedirect(urlParams.get('redirect') || '/'); // Default to home if no redirect param
  }, []);

  return (
    <div className="page-container">
      <div className="login-container text-center">
        <div className="flex items-center justify-center py-3 bg-discord-gray text-white" >
          <div className="flex flex-col items-center">
            <h1 className="text-4xl font-bold">Welcome to SquadBot</h1>
            <p className="text-lg mt-4">Click the button below to login with Discord<br /><br /></p>
            <a id="login" href={`${API_BASE_URL}:${PORT}/api/discord/auth`} className="bg-discord-blue  text-xl px-5 py-3 rounded-md font-bold flex items-center space-x-4 hover:bg-gray-600 transition duration-75">
              <FontAwesomeIcon icon={faDiscord} />
              <span> Login with Discord</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

      export default Login;
